import React, { useState } from "react";
import { EditQuickButton } from "../../revampComponents/Atom/Buttons";
import CreateEventProfileModal from "../../revampPages/ManageEvents/EventProfile/EventProfileModal/CreateEventProfileModal";
import backbtn from '../../assets/images/back-btn.svg';
import { useHistory } from "react-router-dom";

const ManageProfileHeader = ({ manageProfileDetails, fetchEventProfileDetails }) => {
    const history = useHistory();

    const [showModal, setShowModal] = useState(false);
    return (
        <div>
            <div className="event-profile-heading">
                <img src={backbtn} alt="" className="richtext-cursor-pointer" onClick={() => history.goBack()} />
                <span className="px-2">
                    {manageProfileDetails?.name}
                </span>
                <span>
                    <EditQuickButton size="15px" onClick={() => setShowModal(true)} />
                </span>
            </div>
            <CreateEventProfileModal
                show={showModal}
                onClose={() => setShowModal(false)}
                editProfile={true}
                manageProfileDetails={manageProfileDetails}
                fetchEventProfileDetails={fetchEventProfileDetails}
            />
            <style>{`
                        .event-profile-heading {
                            font-size: 20px;
                            font-weight: 700;
                            color: #183b56;
                            margin-bottom: 18px;
                            margin-left: 4px;
                        }
                    `}</style>
        </div>
    );
};

export default ManageProfileHeader;
